<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/Page-header";
import vue2Dropzone from "vue2-dropzone";

/**
 * Starter component
 */
export default {
  head () {
    return {
      title: `${this.title} | Minton - Nuxtjs Responsive Admin Dashboard Template`,
    };
  },
  data () {
    return {
      title: "文法小測驗",
      items: [
        {
          text: "法語鸚鵡螺",
          href: "/",
        },
        {
          text: "文法測驗第一層級",
          link: "/plugin/voices/list"
        },
        {
          text: "文法測驗第二層級",
          active: true,
        },
        {
          text: "模組題目管理",
          active: true,
        }
      ],
      type: 1,
      pluginItem: {
        id: "",
        type: "",
        title: "",
        des: "",
        voice: "",
        note: ""
      },
      saveing: false,
      playing: false,
      topics: []
    };
  },
  components: {
    Layout,
    PageHeader
  },
  created () {
    if (this.$route.params.itemId) {
      this.itemId = this.$route.params.itemId
    }
    this.getPluginTopics()
  },
  methods: {
    getPluginTopics () {
      this.$root.apis.getPluginTopics(this.itemId, this.processGetTopicSuccess)
    },
    processGetTopicSuccess (_response) {
      let items = _response.body.items

      // 重新設置 sort 位置
      items.forEach(function (_item, _index) {
        items[_index].sort = (_index + 1)
      })

      this.topics = items
    },
    createTopic () {
      this.pluginItem = {
        id: "",
        type: "",
        title: "",
        des: "",
        voice: "",
        note: ""
      }
      this.$bvModal.show('modal-responsive')
    },
    editorTopic (_topic) {
      this.pluginItem = _topic
      this.$bvModal.show('modal-responsive')
    },
    createItem () {
      let vm = this
      // 先進行聲音檔案生成作業
      this.saveing = true
      let postData = { text: this.pluginItem.title }
      this.$root.apis.generateVoice(postData, function (_response) {
        vm.pluginItem.voice = _response.body.url
        vm.$root.apis.createPluginTopics(vm.itemId, vm.pluginItem, vm.processCreateItemSuccess)
      })
    },
    processCreateItemSuccess () {
      this.$bvModal.hide('modal-responsive')
      this.getPluginTopics()
      this.saveing = false
    },
    updateItem () {
      let vm = this
      // 先進行聲音檔案生成作業
      this.saveing = true
      let postData = { text: this.pluginItem.title }
      this.$root.apis.generateVoice(postData, function (_response) {
        vm.$root.apis.putTopicItem(vm.pluginItem.id, vm.pluginItem, function () {
          vm.$bvModal.hide('modal-responsive')
          vm.saveing = false
          vm.getPluginTopics()
        })
      })
    },
    removeItem (_itemId) {
      if (!confirm("確認要刪除項目嗎？")) {
        return
      }

      this.$root.apis.delTopicItem(_itemId, this.getPluginTopics)
    },
    playAudio (url, onEndedCallback = null) {
      console.log("播放指定檔案:", url);
      const audio = new Audio(url);

      // 播放結束事件
      if (typeof onEndedCallback === 'function') {
        audio.addEventListener('ended', onEndedCallback);
      }

      this.playing = true

      audio.play().catch(error => {
        console.error("無法播放音訊：", error);
      });
    },
    playStop () {
      this.playing = false
    },
    resetSort (_itemId, _setSort) {
      // 找到項目的原始索引
      const oldIndex = this.topics.findIndex(item => item.id === _itemId);
      if (oldIndex === -1) return;
      const newIndex = Number(_setSort) - 1;

      // 將該項目從陣列中移除
      const [movedItem] = this.topics.splice(oldIndex, 1);

      // 將項目插入到目標位置
      if (newIndex >= this.topics.length) {
        this.topics.push(movedItem);
      } else {
        this.topics.splice(newIndex, 0, movedItem);
      }

      // 重新編號 sort 為連續的 1、2、3...
      this.topics.forEach((item, index) => {
        item.sort = index + 1;
      });

      // 組建後端所需的 payload
      const payload = this.topics.map(item => ({ id: item.id, sort: item.sort }));

      // 送出更新作業
      this.sendSortData(payload);
    },
    sendSortData (_payload) {
      // 呼叫 API 更新排序，完成後重新取得列表
      let vm = this
      this.$root.apis.setTopicSort(this.itemId, { sorts: _payload }, () => {
        vm.getPluginTopics();
      });
    },
    setChageVoiceFile (event) {
      const file = event.target.files[0];
      if (!file) return;
      // 準備 form-data
      const formData = new FormData();
      formData.append('files[0]', file);
      this.saveing = true;
      // 呼叫上傳 API
      this.$http.post(this.$root.uploadUri + '/topic/default', formData).then(_response => {
        // 假設回傳結構為 { data: [ { url: '...' } ] }
        const uploaded = _response.body.data;
        if (Array.isArray(uploaded) && uploaded.length > 0) {
          this.pluginItem.voice = uploaded[0].url;
        }
        this.saveing = false;
        alert("上傳成功")
      }).catch(err => {
        console.error('檔案上傳失敗', err);
        this.saveing = false;
      });
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-lg-12 col-xl-12">
        <!-- Simple card -->
        <b-card>
          <div class="row">
            <div class="col-9"></div>
            <div class="col-3 text-right">
              <b-button variant="primary" type="button" @click="createTopic">增加</b-button>
            </div>
          </div>

        </b-card>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-borderless mb-0">
                <thead class="thead-light">
                  <tr class="text-center">
                    <th>排序</th>
                    <th>發音</th>
                    <th>類型</th>
                    <th>題目</th>
                    <th>翻譯</th>
                    <th>附註</th>
                    <th>操作</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!topics.length">
                    <td colspan="7" class="text-center">無資料</td>
                  </tr>
                  <tr v-for="(topic, index) in topics">
                    <td class="text-center">
                      <select class="form-control" v-model="topic.sort" @change="resetSort(topic.id, topic.sort)">
                        <option v-for="n in topics.length" :value="n">{{ n }}</option>
                      </select>
                    </td>
                    <td class="text-center">
                      <b-button v-if="!playing" size="sm" variant="success"
                        @click="playAudio($root.mediaUri + topic.voice, playStop)">
                        <i class="fe-play"></i>
                      </b-button>
                      <b-spinner v-else small variant="secondary" role="status"></b-spinner>
                    </td>
                    <td class="text-center">
                      <span v-if="topic.type == 1">單詞</span>
                      <span v-if="topic.type == 2">句子</span>
                    </td>
                    <td>{{ topic.title }}</td>
                    <td>{{ topic.des }}</td>
                    <td>{{ topic.note }}</td>
                    <td class="text-center">
                      <b-button size="sm" variant="primary" @click="editorTopic(topic)">編輯</b-button>
                      <b-button class="ml-1" size="sm" variant="danger" @click="removeItem(topic.id)">移除</b-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>

    <b-modal id="modal-responsive" :title="(pluginItem.id) ? '編輯模組' : '新增模組'" title-class="font-18" body-class="p-4"
      hide-footer>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label for="field-1" class="control-label">類型</label>
            <select id="field-1" class="form-control" v-model="pluginItem.type">
              <option value="1">單詞</option>
              <option value="2">句子</option>
            </select>
          </div>
        </div>
        <div class="col-md-6" v-if="pluginItem.id">
          <div class="form-group text-right">
            <b-button v-if="!playing" size="sm" variant="success"
              @click="playAudio($root.mediaUri + pluginItem.voice, playStop)">
              <i class="fe-play"></i>
            </b-button>
            <b-spinner v-else small variant="secondary" role="status"></b-spinner>
            <div class="text-left pt-1">
              上傳替代聲音
              <input type="file" @change="setChageVoiceFile">
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="form-group">
            <label for="field-2" class="control-label">題目</label>
            <input v-model="pluginItem.title" class="form-control" placeholder="" />
          </div>
        </div>

        <div class="col-md-12">
          <div class="form-group">
            <label for="field-2" class="control-label">翻譯</label>
            <input v-model="pluginItem.des" class="form-control" placeholder="" />
          </div>
        </div>

        <div class="col-md-12">
          <div class="form-group">
            <label for="field-2" class="control-label">備註</label>
            <textarea v-model="pluginItem.note" class="form-control" placeholder="" />
          </div>
        </div>
      </div>
      <div class="text-center pt-3">
        <b-spinner v-if="saveing" class="m-2" variant="secondary" role="status"></b-spinner>
        <b-button v-else-if="!pluginItem.id" type="button" @click="createItem">建立</b-button>
        <b-button v-else type="button" @click="updateItem">更新</b-button>
      </div>
    </b-modal>
  </Layout>
</template>
